export type RegistrationStatus =
  | 'new'
  | 'customStartDatePending'
  | 'waitlist'
  | 'contractFinalization'
  | 'completed'
  | 'deleted'
  | 'cancellationRequested'
  | 'cancelled';

export interface StatusConfig {
  type: 'success' | 'warning' | 'error' | 'info';
  label: string;
  action: string;
  styles: {
    background: string;
    color: string;
  };
}

export const RegistrationStatusConfigs: Record<
  RegistrationStatus,
  StatusConfig
> = {
  new: {
    type: 'info',
    label: $localize`:@@lib.registration-status.new:Neu`,
    action: $localize`:@@lib.registration-status.newAction:Die Anmeldung ist eingegangen und wird geprüft.`,
    styles: { background: 'var(--theme-accent)', color: '#fff' },
  },

  customStartDatePending: {
    type: 'info',
    label: $localize`:@@lib.registration-status.customStartDatePending:Startdatum wird geprüft`,
    action: $localize`:@@lib.registration-status.customStartDatePendingAction:Die Anmeldung ist eingegangen und ihr gewünschtes Startdatum wird geprüft.`,
    styles: { background: 'var(--theme-accent)', color: '#fff' },
  },

  waitlist: {
    type: 'warning',
    label: $localize`:@@lib.registration-status.waitlist:Warteliste`,
    action: $localize`:@@lib.registration-status.waitlistAction:Sie befinden sich auf der Warteliste. Wir werden Sie informieren, sobald ein Platz verfügbar wird.`,
    styles: { background: 'var(--theme-orange)', color: '#fff' },
  },
  contractFinalization: {
    type: 'info',
    label: $localize`:@@lib.registration-status.contractFinalization:Vertragsphase`,
    action: $localize`:@@lib.registration-status.contractFinalizationAction:Die Anmeldung wurde angenommen. Bitte füllen Sie die restlichen Vertragsdaten aus.`,
    styles: { background: 'var(--theme-accent)', color: '#fff' },
  },

  completed: {
    type: 'success',
    label: $localize`:@@lib.registration-status.completed:Abgeschlossen`,
    action: $localize`:@@lib.registration-status.completedAction:Die Anmeldung wurde erfolgreich abgeschlossen.`,
    styles: { background: 'var(--theme-success)', color: '#fff' },
  },

  deleted: {
    type: 'error',
    label: $localize`:@@lib.registration-status.deleted:Gelöscht`,
    action: $localize`:@@lib.registration-status.deletedAction:Die Anmeldung wurde gelöscht.`,
    styles: { background: 'var(--theme-warn)', color: '#fff' },
  },

  cancellationRequested: {
    type: 'warning',
    label: $localize`:@@lib.registration-status.cancellationRequested:Kündigung beantragt`,
    action: $localize`:@@lib.registration-status.cancellationRequestedAction:Eine Kündigung wurde beantragt und wird geprüft.`,
    styles: { background: 'var(--theme-orange)', color: '#fff' },
  },

  cancelled: {
    type: 'error',
    label: $localize`:@@lib.registration-status.cancelled:Gekündigt`,
    action: $localize`:@@lib.registration-status.cancelledAction:Die Anmeldung wurde gekündigt.`,
    styles: { background: 'var(--theme-error)', color: '#fff' },
  },
};

export const RegistrationStatusGroups = {
  pending: ['new', 'customStartDatePending', 'waitlist'],
  confirmed: ['contractFinalization', 'completed'],
  rejected: ['applicationRejected', 'rejected', 'contractNotPossible'],
  cancelled: ['deleted', 'cancellationRequested', 'cancelled'],
} as const;

export const RegistrationStatusOptions = [
  { value: '', label: $localize`:@@lib.registration-status.all:Alle` },
  ...Object.entries(RegistrationStatusConfigs).map(([value, config]) => ({
    value,
    label: config.label,
  })),
];
